import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData } from "./infoenum";
import { isNaviTEKType } from "../../../../../common/utils";

class TraceRouteResult extends React.Component {
  constructor(props) {
    super(props);
    const { job } = this.props;

    this.state = {
      isNavitek: job && isNaviTEKType(job.deviceid),
      bodyHeight: null // height of the scrollable rows area, fitted to the window
    };
    this.updateBodyHeight = this.updateBodyHeight.bind(this);
  }
  // Size the scrollable rows area so the table reaches the bottom of the visible page
  updateBodyHeight() {
    if (!this.bodyEl) return;
    const BOTTOM_GAP = 24; // space left below the table (Paper padding + margin)
    const MIN_HEIGHT = 200; // never smaller than this on short windows
    const top = this.bodyEl.getBoundingClientRect().top + window.pageYOffset;
    const height = Math.max(MIN_HEIGHT, window.innerHeight - top - BOTTOM_GAP);
    if (Math.abs(height - (this.state.bodyHeight || 0)) > 1) {
      this.setState({ bodyHeight: height });
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateBodyHeight);
    this.updateBodyHeight();
  }
  componentDidUpdate() {
    // The table only appears once results have loaded, so measure again after updates
    this.updateBodyHeight();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateBodyHeight);
  }
  // Same column widths for the header table and the body table, so the columns line up
  renderColGroup() {
    const widths = this.state.isNavitek
      ? ["5%", "16%", "18%", "7%", "7%", "7%", "10%", "10%", "10%", "10%"]
      : ["6%", "18%", "28%", "16%", "16%", "16%"];
    return (
      <colgroup>
        {widths.map((width, i) => (
          <col key={i} style={{ width }} />
        ))}
      </colgroup>
    );
  }
  render() {
    const {
      classes,
      result,
      subtest,
      subtestSignaltekResults,
      translate
    } = this.props;

    return subtestSignaltekResults && subtestSignaltekResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={1} />
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_started")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestSignaltekResults.teststarted
                  ? moment(subtestSignaltekResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_test_duration")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.testduration
                  ? subtestSignaltekResults.testduration
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_target")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.target}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGrid}>
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_no_of_hops")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestSignaltekResults.numberofhops}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.totalGridLast}>
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "7px" }}
                color="inherit"
              >
                {translate("result_info_status")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestSignaltekResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText}>
                      {infoData.find(
                        o => o.name === subtestSignaltekResults.info
                      )
                        ? " " +
                          translate(
                            infoData.find(
                              o => o.name === subtestSignaltekResults.info
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
            <Grid item xs={1} />
          </Grid>
          <div className={classes.div_table1}>
            <div className={classes.div_table_head}>
            <Table className={classes.table}>
              {this.renderColGroup()}
              <TableHead className={classes.thead}>
                <TableRow>
                  <TableCell className={classes.tableheader_first} rowSpan={2}>
                    {translate("result_head_hop")}
                  </TableCell>
                  <TableCell className={classes.tableheader} rowSpan={2}>
                    {translate("result_head_ip")}
                  </TableCell>
                  <TableCell className={classes.tableheader} rowSpan={2}>
                    {translate("result_head_host")}
                  </TableCell>
                  <TableCell
                    className={classes.tableheaderlast}
                    colSpan={3}
                    align="center"
                  >
                    {translate("result_delay")}
                  </TableCell>
                  {this.state.isNavitek && (
                    <TableCell
                      className={classes.tableheaderlast}
                      colSpan={4}
                      align="center"
                    >
                      {"Location"}
                    </TableCell>
                  )}
                </TableRow>
                <TableRow>
                  <TableCell
                    borderBottom="none"
                    className={classes.tableheaderlast}
                  >
                    {translate("result_head_probe1")}
                  </TableCell>
                  <TableCell className={classes.tableheaderlast}>
                    {translate("result_head_probe2")}
                  </TableCell>
                  <TableCell className={classes.tableheaderlast}>
                    {translate("result_head_probe3")}
                  </TableCell>
                  {this.state.isNavitek && (
                    <TableCell className={classes.tableheaderlast}>
                      {"Country"}
                    </TableCell>
                  )}
                  {this.state.isNavitek && (
                    <TableCell className={classes.tableheaderlast}>
                      {"City"}
                    </TableCell>
                  )}
                  {this.state.isNavitek && (
                    <TableCell className={classes.tableheaderlast}>
                      {"Region"}
                    </TableCell>
                  )}
                  {this.state.isNavitek && (
                    <TableCell className={classes.tableheaderlast}>
                      {"ASN Organisation"}
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
            </Table>
            </div>
            <div
              className={classes.div_table2}
              ref={el => (this.bodyEl = el)}
              style={this.state.bodyHeight ? { height: this.state.bodyHeight } : undefined}
            >
            <Table className={classes.table}>
              {this.renderColGroup()}
              <TableBody>
                {subtestSignaltekResults &&
                subtestSignaltekResults.traceroutedata &&
                subtestSignaltekResults.traceroutedata.length
                  ? subtestSignaltekResults.traceroutedata.map((item, k) => {
                      const location = item.location && (item.location.indexOf("{") != -1) ? JSON.parse(item.location) : null;
                      return (
                        <TableRow key={k}>
                          <TableCell className={classes.tablecontent_first}>
                            {item.hop}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.ipaddress}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.hostname}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.probe1 != -1 ? item.probe1.toFixed(1) : "-"}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.probe2 != -1 ? item.probe2.toFixed(1) : "-"}
                          </TableCell>
                          <TableCell className={classes.tablecontent}>
                            {item.probe3 != -1 ? item.probe3.toFixed(1) : "-"}
                          </TableCell>
                          {this.state.isNavitek && (
                            <TableCell className={classes.tablecontent}>
                              {location && location.countryName ? location.countryName : translate("Unavailable")}
                            </TableCell>
                          )}
                          {this.state.isNavitek && (
                            <TableCell className={classes.tablecontent}>
                              {location && location.cityName ? location.cityName : translate("Unavailable")}
                            </TableCell>
                          )}
                          {this.state.isNavitek && (
                            <TableCell className={classes.tablecontent}>
                              {location && location.regionName ? location.regionName : translate("Unavailable")}
                            </TableCell>
                          )}
                          {this.state.isNavitek && (
                            <TableCell className={classes.tablecontent}>
                              {location && location.asnOrganization ? location.asnOrganization : translate("Unavailable")}
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
            </div>
          </div>
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getSubtestResults, subtest, pager } = this.props;

    getSubtestResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const { getSubtestResults, subtest, pager } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getSubtestResults(pager.jid, pager.tid, subtest, null);
    }
  }
}

export default withStyles(styles)(TraceRouteResult);
